<div class="rd-panel" *ngIf="row">
  <section class="rd-card">
    <div class="rd-card__header">
      <span class="rd-card__title" [title]="row.investmentDescription"><mat-icon>home</mat-icon> {{ row.investmentDescription || 'Inversión inmobiliaria' }}</span>
      <app-status-pill [label]="paidLabel" [variant]="paidVariant"></app-status-pill>
    </div>

    <div class="rd-progress">
      <div class="rd-progress__bar">
        <div class="rd-progress__fill" [style.width.%]="percent"></div>
      </div>
      <div class="rd-progress__legend">
        <span>Pagado <strong>{{ row.totalPaid | number:'1.2-2' }} €</strong></span>
        <span>Pendiente <strong>{{ row.pending | number:'1.2-2' }} €</strong></span>
        <span>Total <strong>{{ row.total | number:'1.2-2' }} €</strong></span>
      </div>
    </div>

    <div class="rd-kpis">
      <div class="rd-kpi">
        <span class="rd-kpi__label">Base</span>
        <span class="rd-kpi__value">{{ row.base | number:'1.2-2' }} €</span>
      </div>
      <div class="rd-kpi">
        <span class="rd-kpi__label">Impuestos</span>
        <span class="rd-kpi__value" [title]="taxesLabel">{{ row.taxAmount | number:'1.2-2' }} €</span>
      </div>
      <div class="rd-kpi">
        <span class="rd-kpi__label">Uso</span>
        <span class="rd-kpi__value">{{ usageLabel }}</span>
      </div>
      <div class="rd-kpi">
        <span class="rd-kpi__label">Coeficiente lineal</span>
        <span class="rd-kpi__value">{{ row.maximumLinearCoefficient }} %</span>
      </div>
      <div class="rd-kpi">
        <span class="rd-kpi__label">Periodo máximo</span>
        <span class="rd-kpi__value">{{ row.maximumPeriod }} años</span>
      </div>
      <div class="rd-kpi">
        <span class="rd-kpi__label">Valor residual</span>
        <span class="rd-kpi__value">{{ row.residualValue | number:'1.2-2' }} €</span>
      </div>
    </div>

    <div class="rd-lines">
      <div class="rd-line">
        <span class="rd-line__label">Proveedor</span>
        <span class="rd-line__value">{{ row.contactsName || '—' }}</span>
      </div>
      <div class="rd-line">
        <span class="rd-line__label">Cuenta contable</span>
        <span class="rd-line__value">{{ row.accountingModelsNumber || '—' }}</span>
      </div>
      <div class="rd-line">
        <span class="rd-line__label">Fecha de compra</span>
        <span class="rd-line__value">{{ row.investmentDate ? (row.investmentDate | date:'dd/MM/yyyy') : '—' }}</span>
      </div>
      <div class="rd-line">
        <span class="rd-line__label">Referencia catastral</span>
        <span class="rd-line__value">{{ row.cadastralReference || '—' }}</span>
      </div>
      <div class="rd-line">
        <span class="rd-line__label">Compra construcción / suelo</span>
        <span class="rd-line__value">{{ row.purchaseValueConstruction | number:'1.2-2' }} € · {{ row.landPurchaseValue | number:'1.2-2' }} €</span>
      </div>
      <div class="rd-line">
        <span class="rd-line__label">Valor catastral (constr. / suelo)</span>
        <span class="rd-line__value">{{ row.cadastralValue | number:'1.2-2' }} € ({{ row.cadastralValueConstruction | number:'1.2-2' }} € / {{ row.cadastralValueLand | number:'1.2-2' }} €)</span>
      </div>
      <div class="rd-line">
        <span class="rd-line__label">Local / oficina empresa</span>
        <span class="rd-line__value">{{ row.companyPremisesOrOffice ? 'Sí' : 'No' }}</span>
      </div>
    </div>

    <div class="rd-actions">
      <button mat-stroked-button class="cf-btn cf-btn--primary" (click)="edit.emit()">
        <mat-icon>edit</mat-icon> Editar inversión
      </button>
    </div>
  </section>

  <section class="rd-card">
    <div class="rd-card__header">
      <span class="rd-card__title"><mat-icon>date_range</mat-icon> Operaciones de la inversión</span>
    </div>

    <app-loading-state *ngIf="loading" [compact]="true" message="Cargando pagos…"></app-loading-state>

    <div class="rd-empty rd-empty--error" *ngIf="!loading && error">
      <mat-icon>error</mat-icon>
      <span>No se pudieron cargar los pagos de la inversión.</span>
      <button mat-stroked-button class="cf-btn" (click)="retry()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>

    <ng-container *ngIf="!loading && !error">
      <div class="rd-kpis rd-kpis--compact">
        <div class="rd-kpi rd-kpi--accent">
          <span class="rd-kpi__label">Pagado en {{ year }}</span>
          <span class="rd-kpi__value">{{ paidYear | number:'1.2-2' }} €</span>
        </div>
        <div class="rd-kpi">
          <span class="rd-kpi__label">Nº de pagos</span>
          <span class="rd-kpi__value">{{ count }}</span>
        </div>
        <div class="rd-kpi">
          <span class="rd-kpi__label">Comisiones</span>
          <span class="rd-kpi__value">{{ commissions | number:'1.2-2' }} €</span>
        </div>
      </div>

      <div class="rd-block">
        <div class="rd-block__header">
          <span class="rd-block__title"><mat-icon>payment</mat-icon> Pagos</span>
          <span class="rd-block__side">
            <span class="rd-block__summary" *ngIf="count > 0">
              {{ count }} · <strong>{{ row.totalPaid | number:'1.2-2' }} €</strong>
            </span>
            <button mat-stroked-button type="button" class="cf-btn cf-btn--primary rd-add" (click)="add()">
              <mat-icon>add</mat-icon> Añadir
            </button>
          </span>
        </div>

        <div class="rd-moves" *ngIf="lines.length">
          <div class="rd-move" *ngFor="let line of lines; trackBy: trackByUid">
            <span class="rd-move__date">{{ line.date | date:'dd/MM/yyyy' }}</span>
            <span class="rd-move__info">
              <span class="rd-move__concept" [title]="line.concept">{{ line.concept }}</span>
              <span class="rd-move__meta" *ngIf="line.meta" [title]="line.meta">{{ line.meta }}</span>
            </span>
            <span class="rd-move__amount">{{ line.amount | number:'1.2-2' }} €</span>
            <span class="rd-move__actions">
              <button type="button" class="rd-icon-btn" (click)="editLine(line)" title="Editar" aria-label="Editar pago">
                <mat-icon>edit</mat-icon>
              </button>
              <button type="button" class="rd-icon-btn rd-icon-btn--danger" (click)="deleteLine(line)" title="Eliminar" aria-label="Eliminar pago">
                <mat-icon>delete</mat-icon>
              </button>
            </span>
          </div>
          <button type="button" class="rd-more" *ngIf="count > maxLines" (click)="manage()">
            Ver los {{ count }} pagos <mat-icon>chevron_right</mat-icon>
          </button>
        </div>

        <div class="rd-block__empty" *ngIf="!lines.length">Sin pagos registrados</div>
      </div>
    </ng-container>
  </section>
</div>
